// @flow

import { INITIALIZE_SUCCESS } from '../core/actions';
import { SET_TIME_CLOCK_DATA } from '../timeClock/actions';
import type {
  SignOutAction,
  LogInAction,
  LogInExternalUserAction,
  LogInSuccessAction,
  LogInFailureAction,
  InitializeSuccessAction,
  SetTimeClockDataAction
} from '../common/typings';

import { LOG_IN, LOG_IN_EXTERNAL_USER, LOG_IN_SUCCESS, LOG_IN_FAILURE, SIGN_OUT } from './actions';

export type State = {|
  +isUserLoggedIn: boolean,
  +pin: string | null,
  +usTimeFormat: boolean,
  +origin: string | null,
  +externalUserId: string | null
|};

type Action =
  | SignOutAction
  | LogInAction
  | LogInExternalUserAction
  | LogInSuccessAction
  | LogInFailureAction
  | InitializeSuccessAction
  | SetTimeClockDataAction;

export const initialState = {
  isUserLoggedIn: false,
  pin: null,
  usTimeFormat: true,
  origin: null,
  externalUserId: null
};

export default function authentication(state: State = initialState, action: Action) {
  switch (action.type) {
    case SIGN_OUT:
      return {
        ...state,
        pin: null,
        isUserLoggedIn: false
      };
    case LOG_IN:
      return {
        ...state,
        pin: action.payload.pin
      };
    case LOG_IN_EXTERNAL_USER:
      return {
        ...state,
        externalUserId: action.payload.externalUserId
      };
    case LOG_IN_SUCCESS:
      return {
        ...state,
        isUserLoggedIn: true
      };
    case LOG_IN_FAILURE:
      return {
        ...state,
        pin: null,
        isUserLoggedIn: false
      };
    case INITIALIZE_SUCCESS: {
      const { usTimeFormat = true, origin } = action.payload;
      return {
        ...state,
        origin,
        usTimeFormat: !!usTimeFormat
      };
    }
    case SET_TIME_CLOCK_DATA: {
      const { settings } = action.payload.data;

      if (settings && settings.usTimeFormat) {
        return {
          ...state,
          usTimeFormat: settings.usTimeFormat
        };
      }

      return state;
    }
    default:
      // (action: empty); is a way to enforce exhaustiveness in flow.
      // That means every action provided in Action type have to be handled in reducer.
      (action: empty); // eslint-disable-line
      return state;
  }
}
